import axios from "axios";
function exportsFile(url,params,name) {
  const link = document.createElement('a')
  axios.post(url, params, {responseType: 'arraybuffer'}).then(res => {
      // 创建Blob对象，设置文件类型
      let blob = new Blob([res.data], {type: "application/vnd.ms-excel"})
      let objectUrl = URL.createObjectURL(blob) // 创建URL
      link.href = objectUrl
      link.download = name // 自定义文件名
      link.click() // 下载文件
      URL.revokeObjectURL(objectUrl); // 释放内存
  })
}
export {exportsFile}